import {HgTagGroup, type HgTagProps} from '~/design-system/hg/components'

const HgArticleNotesTagGroup = ({tags}: {tags: HgTagProps[]}) => {
  return (
    <div className="flex flex-col gap-s3 border-t border-border-frosted">
      <p className="pt-s3 arcadia-heading-9">Tags</p>
      <HgTagGroup tags={tags} canWrap />
    </div>
  )
}

export default HgArticleNotesTagGroup
